import React, { useCallback, useId } from "react";
import { useNavigate } from "react-router-dom";
import { FeaturedBenefits, VEBPlansLists } from "../../../../constants/benefits.constants";
import "../../../../components/pages/Home/sections/benefitArticleCard/benefitArticleCard.scss";
import VEBMainImage from "../../../../assets/VEBPlanImages/VEBMainImage.avif";
import "./vebplans.scss";

const VebPlans: React.FC = (): JSX.Element => {
	const _id = useId();
	const navigate = useNavigate();
	const handleExploreClick = () => {
		const contentToScrollTo = document.getElementById("AllPlans");

		if (contentToScrollTo) {
			contentToScrollTo.scrollIntoView({ behavior: "smooth" });
		}
	};

	const handleRedirectToPlanPage = useCallback(
		(planType: string, planRoutePage: string) => {
			const redirectionRoute = `/plans/${planType}/${planRoutePage}`;
			navigate(redirectionRoute);
		},
		[navigate]
	);

	return (
		<>
			<div className="vebGrid">
				<div className="firstVebGrid">
					<h1 className="vebText">VEB</h1>
					<h2 className="vebPlansText">
						Plans <span id="vebspin"> </span>
					</h2>

					<p className="vebDescText">
						Empower Your Well-being with Voluntary Benefits: Tailor Your Coverage with Choices Like Cancer,
						Accident, Dental, Vision, Short-Term Disability, Term Life Insurance, and Hospital Indemnity.
						Personalize Your Safety Net, Enhance Your Health, and Safeguard Your Future. Explore the Array
						of Options Available to You, Each Designed to Provide Peace of Mind and Financial Security. Your
						Holistic Well-being Matters and Our Voluntary Benefits Ensure You Have the Support You Need in
						Every Aspect of Your Life. Discover the Power of Choice – Your Voluntary Benefits, Your Peace,
						Your Protection.
					</p>
				</div>

				<div className="secondCoreGrid">
					<img className="insuranceImg" src={VEBMainImage} alt="VEB main insurance image" />
					<button className="explore-button" onClick={handleExploreClick}>
						Explore
					</button>
				</div>
			</div>

			<h3 className="main-title">Voluntary Plans</h3>

			<div id="AllPlans">
				<div className="benefit-article-main-container" id="benefit-article-main-container">
					<div className="grid-container">
						{VEBPlansLists.map((data: FeaturedBenefits) => {
							const { planType, planRedirectionRoute } = data;
							return (
								<div
									key={_id}
									className="grid-item-container"
									onClick={() =>
										handleRedirectToPlanPage(planType.toLowerCase(), planRedirectionRoute)
									}
								>
									<div
										className="sponsored-ribbon-wrapper"
										style={
											data.planType === "VEB"
												? {
														background: "linear-gradient(to right, #a223d1, #4631ce)"
													}
												: {
														background: "linear-gradient(to right, #f40752, #f9ab8f)"
													}
										}
									>
										<div className="glows">&nbsp;</div>
										<span className="ribbon-text">{data.planType === "VEB" && "VEB Plan"}</span>
										<div className="ribbon-text-support"></div>
									</div>
									<div className="grid-item">
										<img src={data.cardImage} alt="" />
										<div className="gradient-ribbon" />
										<span className="card-title">{data.cardTitle}</span>
										<span className="card-description">{data.cardDescription}</span>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</>
	);
};

export default VebPlans;
